import React from "react";
import { Info } from "@mui/icons-material";
import { useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";
import {
  getAllRequisitions,
  getSelectedRequisition,
} from "../../recoil/selectors";
import {
  BabyPeekMultipleReqMessage,
  BabyPeekMultipleReqMessageBorder,
} from "./BabyPeekIntro.styles";
import {
  UpfrontPaymentTooltip,
  UpfrontPaymentTooltipPopper,
  UpfrontPaymentTooltipContent,
} from "../UpfrontPayment/UpfrontPayment.styles";
import useBabyPeek from "../../utils/hooks/useBabyPeek";
import { getReqDisplayDate } from "../../utils/dateUtils";

const BabyPeekMultipleReqHeader: React.FC = () => {
  const { t } = useTranslation();
  const requisitions = useRecoilValue(getAllRequisitions);
  const { isMostRecentRequisition } = useBabyPeek();
  const specificRequisition = useRecoilValue(getSelectedRequisition);
  const displayDate = specificRequisition
    ? getReqDisplayDate(specificRequisition)
    : "";

  return (
    <>
      {requisitions && requisitions?.length > 1 && (
        <>
          <BabyPeekMultipleReqMessage>
            <>
              {isMostRecentRequisition
                ? t("babyPeek.multipleReq.mostRecent")
                : t("babyPeek.multipleReq.receivedOn", { displayDate })}
            </>
            <UpfrontPaymentTooltip
              PopperComponent={UpfrontPaymentTooltipPopper}
              enterTouchDelay={0}
              leaveTouchDelay={5000}
              title={
                <UpfrontPaymentTooltipContent>
                  {t("babyPeek.multipleReq.tooltip")}
                </UpfrontPaymentTooltipContent>
              }
            >
              <div>
                <Info style={{ color: "#464547" }} />
              </div>
            </UpfrontPaymentTooltip>
          </BabyPeekMultipleReqMessage>
          <BabyPeekMultipleReqMessageBorder />
        </>
      )}
    </>
  );
};

export default BabyPeekMultipleReqHeader;
